import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/Megaphone.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...a, weights: n }));
o.displayName = "MegaphoneIcon";
const c = o;
export {
  c as Megaphone,
  o as MegaphoneIcon
};
